<template>
  <div :class="deriveClass">
    <label class="field-title" :class="{'on': internalValue || focussed || placeholder}">
      {{displayLabel}}
    </label>
    <input :maxlength='maxlength' ref='input' :id="id" @keyup="keyup($event)" type="text" :value="internalValue"
        @input="input($event)" :readonly="readonly" :required="required" :placeholder="placeholderContent" @focus="focus($event)" @blur="blur($event)" />
    <slot></slot>
    <template v-if="config.help_text">
      <span class="help-text" @click="showHelpText()">
        <!-- TODO fix image path -->
        <img src="/src/assets/img/i.png">
      </span>
      <div ref="helpText" class="help-text-content" :class="{'show': helpTextShown}" v-show="helpTextShown">
        {{config.help_text}}
      </div>
    </template>
    <p class="error-msg" v-if="!!errorMessage && !focussed">
      {{errorMessage}}
    </p>
  </div>
</template>

<script>

import Validators from "./../helpers/validators.js";

export default {
  name: 'text-field',
  data () {
    return {
      id: this.config.id,
      name: this.config.name,
      optional: !this.config.required,
      label: this.config.label,
      readonly: this.config.read_only,
      required: this.config.required,
      placeholder: "",
      focussed: false,
      internalValue: this.value || this.config.def_value,
      helpTextShown: false,
      errorMessage: "",
      invalid: false
    }
  },
  // DONT use value until data initialization happens first
  props: ['config', 'value', 'customclass', 'attrs', 'maxlength'],
  computed: {
    displayLabel() {
      return !this.optional ? this.label : this.label + " (Optional)";
    },

    placeholderContent() {
      return this.internalValue || this.focussed ? null : this.placeholder;
    },

    deriveClass() {
      var o = {
        'optional': this.optional,
        'focus-input': this.focussed,
        'error': this.invalid
      }
      if(this.customclass) {
        o[this.customclass] = true;
      }
      return o;
    }
  },

  mounted() {
  },

  methods: {
    input(event) {
      var value = event.target.value;
      this.internalValue = value;
      this.$emit('input', value);
    },

    keyup(event) {
      this.$emit('keyup', event);
    },

    blur(event) {
      this.focussed = false;
      this.helpTextShown = false;
      this.validate();
    },

    focus(event) {
      this.focussed = true;
      if(!this.helpTextShown) {
        this.helpTextShown = true;
      }
    },

    validate() {
      this.attrs && Object.keys(this.attrs).forEach(attr => {
        this.$refs.input.dataset[attr] = this.attrs[attr];
      });
      var validations = this.config.validations;
      if(validations) {
        Object.keys(validations).some(key => {
          this.errorMessage = Validators[key] && Validators[key](this.$refs.input, validations[key]);
          return !!this.errorMessage;
        });
      }
      this.invalid = !!this.errorMessage;
    },

    showHelpText() {
      if(this.helpTextShown) {
        // remove event listener
        document.removeEventListener('click', this.closeHelpText);
      }
      else {
        document.addEventListener('click', this.closeHelpText);
      }
      this.helpTextShown = !this.helpTextShown;
      event.stopPropagation();
    },

    closeHelpText(event) {
      var helpTextElement = this.$refs.helpText;
      if(event.target != helpTextElement) {
        document.removeEventListener('click', this.closeHelpText);
        this.helpTextShown = false;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// TextField.vue?09d4a0ad